import { render, staticRenderFns } from "./CookiesUseModal.vue?vue&type=template&id=0b0ca18a"
import script from "./CookiesUseModal.vue?vue&type=script&lang=js"
export * from "./CookiesUseModal.vue?vue&type=script&lang=js"
import style0 from "./CookiesUseModal.vue?vue&type=style&index=0&id=0b0ca18a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports